export { default as FontAwesomeIcon } from './dist/components/FontAwesomeIcon'
